import { useEffect, useState } from 'react';
import { mdiAccountOutline, mdiClose } from '@mdi/js';
import Icon from '@mdi/react';
import { Input, Label, Modal, ModalBody } from 'reactstrap';
import './CalibrationFilterModal.scss';
import { useQuery } from '@tanstack/react-query';
import {
  AsyncAutocompleteSelect,
  UserAsyncAutocompleteSelect,
} from '../../../../components/Common';
import { getAuthUser } from '../../../../utils/auth.util';
import {
  fetchClassification,
  fetchDelegateApprovalAutoComplete,
  fetchEmployeeSearchAutoComplete,
} from '../../../../store/apis/autocompleteService';
import { fetchHRCodeList } from '../../../../store/apis/commonService';

function CalibrationFilterModal({ isOpen, toggle, filterData, data }) {
  const [companyCode, setCompanyCode] = useState(null);
  const [manager, setManager] = useState(null);
  const [employee, setEmployee] = useState(null);
  const [department, setDepartment] = useState(null);
  const [classification, setClassification] = useState(null);
  const { companyList } = getAuthUser();

  const { data: departmentList } = useQuery({
    queryKey: ['departmentList'],
    queryFn: () => fetchHRCodeList({ type: 'DEPT_ACTIVE' }),
    enabled: true,
    keepPreviousData: true,
  });

  const submitFilterData = () => {
    const submitData = {
      companyCode: companyCode ?? null,
      manager: manager ?? null,
      employee: employee ?? null,
      department: department ?? null,
      classification: classification ?? null,
    };
    filterData(submitData);
    toggle();
  };

  useEffect(() => {
    setCompanyCode(data.companyCode);
    setManager(data.manager);
    setEmployee(data.employee);
    setDepartment(data.department);
    setClassification(data.classification);
  }, [data]);
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="xl">
      <div className="modal-header p-0">
        <div className="py-2 px-3 d-flex flex-row align-items-center justify-content-between w-100">
          <div className="h5 mb-0">Filter</div>
          <div className="d-flex flex-row align-items-center gap-2">
            <button className="btn btn-link" type="button" onClick={toggle}>
              <Icon path={mdiClose} size={0.8} />
            </button>
          </div>
        </div>
      </div>
      <ModalBody className="p-0 pb-3">
        <div className="internal-filter-calibration gap-3 mx-2 mt-2 mb-3 p-3">
          <div className="filter-row gap-2">
            <div className="external-cb-filter-col">
              <Label className="label">Company</Label>
              <Input
                type="select"
                onChange={event =>
                  setCompanyCode(
                    companyList.find(
                      cl => cl.Code === event.target.value.trim(),
                    ),
                  )
                }
                className="external-filter-input"
                value={companyCode?.Code}
              >
                <option value="">All</option>
                {companyList?.map(type => (
                  <option key={type.Code} value={type.Code}>
                    {type.Description}
                  </option>
                ))}
              </Input>
            </div>
            <div className="external-cb-filter-col">
              <Label className="label">Employee</Label>
              <UserAsyncAutocompleteSelect
                autoCompleteFn={input =>
                  fetchDelegateApprovalAutoComplete({
                    prefixText: input,
                  })
                }
                mappedFn={rawData =>
                  rawData.map(item => ({
                    value: item.Cd,
                    label: item.Name,
                    name: item.Name,
                    code: item.Cd,
                    image: item?.Imagefile,
                    coCd: item?.CoCd?.trim(),
                  }))
                }
                onChange={selectedOption => setEmployee(selectedOption)}
                value={employee}
                placeholder="Select"
                isClearable
                displayOption="bothCustom"
                inputWidth="100%"
                inputIcon={
                  <Icon path={mdiAccountOutline} size={0.8} color="#667085" />
                }
              />
            </div>
            <div className="external-cb-filter-col">
              <Label className="label">Manager</Label>
              <UserAsyncAutocompleteSelect
                autoCompleteFn={input =>
                  fetchEmployeeSearchAutoComplete({
                    prefixText: input,
                  })
                }
                mappedFn={rawData =>
                  rawData.map(item => ({
                    value: item.EmpCd,
                    label: item.Name,
                    name: item.Name,
                    code: item.EmpCd,
                    image: item?.Imagefile,
                    coCd: item?.CoCd?.trim(),
                  }))
                }
                onChange={selectedOption => setManager(selectedOption)}
                value={manager}
                placeholder="Select"
                isClearable
                isSearchable
                displayOption="bothCustom"
                inputWidth="100%"
                inputIcon={
                  <Icon path={mdiAccountOutline} size={0.8} color="#667085" />
                }
              />
            </div>
            <div className="external-cb-filter-col">
              <Label className="label">Department</Label>
              <Input
                type="select"
                className="external-filter-input"
                onChange={event =>
                  setDepartment(
                    departmentList.find(cl => cl.Code === event.target.value),
                  )
                }
                value={department?.Code}
              >
                <option value="">Select</option>
                {departmentList?.map(type => (
                  <option key={type.Code} value={type.Code}>
                    {type.Description}
                  </option>
                ))}
              </Input>
            </div>
            <div className="external-cb-filter-col">
              <Label className="label">Classification</Label>
              <AsyncAutocompleteSelect
                autoCompleteFn={input =>
                  fetchClassification({
                    prefixText: input,
                  })
                }
                mappedFn={rawData =>
                  rawData.map(item => ({
                    value: item.Cd,
                    label: item.Des,
                  }))
                }
                onChange={selectedOption => setClassification(selectedOption)}
                value={classification}
                placeholder="Select"
                isClearable
                displayOption="bothCustom"
                inputWidth="100%"
                inputIcon={
                  <Icon path={mdiAccountOutline} size={0.8} color="#667085" />
                }
              />
            </div>
          </div>
          <div className="filter-action">
            <button
              type="button"
              className="search-calibration-btn justify-center"
              onClick={() => submitFilterData()}
            >
              Search
            </button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default CalibrationFilterModal;
